import React, { useState, useEffect, useContext } from 'react';

import { useNavigate, Link, useParams } from 'react-router-dom';

import { Header, Footer, HeaderBox, Article } from '../../components/imports'

import { APP_NAME } from '../../constants/general'

import Func from '../../class/Func'

import Categories from '../../class/Categories';
import Annonces from '../../class/Annonces';
import PlantSitting from '../../class/PlantSitting';
import { Context } from '../../class/Context';

function PlantSittingAnnonce() {

    const context = useContext(Context)

    const { id } = useParams()

    const navigate = useNavigate()

    const [annonce, setAnnonce] = useState(false)

    const [loading, setLoading] = useState(true)

    const getAnnonce = async (id) => {

        window.scrollTo(0, 0)

        let results = await PlantSitting.post('annonceById', { id: id })

        setLoading(false)

        if (results.success) {

            setAnnonce(results.data)

            document.title = results.data.titre + " - " + APP_NAME

        } else {

            navigate('/404')

        }

    }

    const favoris = async (e, id) => {

        e.preventDefault()

        e.stopPropagation()

        if (!context.session) {

            Func.setFlash("Connectez vous pour ajouter des annonces à vos favoris", "error")

            navigate('/connexion')

            return

        }

        let t = document.querySelector('span.fav_btn')

        let results = await PlantSitting.post('ajoutFavoris', { id: id })

        if (results.success) {

            if (results.action == 'add') {

                t.innerText = 'k'

            } else {

                t.innerText = 'j'

            }

        } else {

            alert(results.message)

        }

    }

    useEffect(() => {

        getAnnonce(id)

        document.title = "Plant Sitting Annonce - " + APP_NAME

    }, [id])

    return (

        <div>

            <Header />

            <div className="plantsitting">

                <HeaderBox />

                {

                    !loading

                        ?

                        <div className="single">

                            <div className='content'>

                                <div className='c'>

                                    <div className="bg7 br8 p20 mb20">
                                        <div className="flex">
                                            <div className='col-7'>
                                                {annonce.categorie_id == 1 && <p className='fw5 fz12'>Je garde tes plantes chez moi</p>}
                                                {annonce.categorie_id == 2 && <p className='fw5 fz12'>J'arrose tes plantes chez toi</p>}
                                                {annonce.categorie_id == 3 && <p className='fw5 fz12'>J'offre un service de jardinage</p>}

                                                <div className="mt30 mb30">

                                                    {
                                                        (annonce.categorie_id == 1 || annonce.categorie_id == 2)

                                                        &&

                                                        <div>
                                                            <span className='fw3 d-block fz12 mb10 fw5'>Tarifs jour (€)</span>

                                                            {

                                                                annonce.tarif1 > 0 &&

                                                                <div className="grid2 col-6 mb20 m_grid2">
                                                                    <span class='fw3'>Entre 1 & 30 plantes</span>
                                                                    <span class='fw5'>{annonce.tarif1}€</span>
                                                                </div>

                                                            }

                                                            {

                                                                annonce.tarif2 > 0 &&

                                                                <div className="grid2 col-6 mb20 m_grid2">
                                                                    <span class='fw3'>Supérieur 30 plantes</span>
                                                                    <span class='fw5'>{annonce.tarif2}€</span>
                                                                </div>

                                                            }

                                                        </div>

                                                    }

                                                    {
                                                        annonce.categorie_id == 3

                                                        &&

                                                        <div>
                                                            <span class='fw3 d-block fz12 mb10 fw5'>Tarif prestation (€)</span>

                                                            {

                                                                annonce.tarif1 > 0 &&

                                                                <div className="grid2 col-6 mb20 m_grid2">
                                                                    <span class='fw3'>Tondre</span>
                                                                    <span class='fw5'>{annonce.tarif1}€</span>
                                                                </div>

                                                            }

                                                            {

                                                                annonce.tarif2 > 0 &&

                                                                <div className="grid2 col-6 mb20 m_grid2">
                                                                    <span class='fw3'>Tailler</span>
                                                                    <span class='fw5'>{annonce.tarif2}€</span>
                                                                </div>

                                                            }

                                                            {

                                                                annonce.tarif3 > 0 &&

                                                                <div className="grid2 col-6 mb20 m_grid2">
                                                                    <span class='fw3'>Nettoyer et Autre</span>
                                                                    <span class='fw5'>{annonce.tarif3}€</span>
                                                                </div>

                                                            }

                                                        </div>
                                                    }

                                                </div>

                                                {/* {
                                            annonce.categorie_id == 2

                                            &&

                                            <div className="grid2 col-6 mb20 m_grid2">
                                                <span class='fw3'>Fréquence / sem</span>
                                                <span class='fw5'>{annonce.frequence == 1 ? '1 passage' : '2 passages'}</span>
                                            </div>

                                        } */}

                                                <div className="grid2 col-6 mb20 m_grid2">
                                                    <span class='fw3'>Localisation</span>
                                                    <span class='fw5'>{annonce.ville}</span>
                                                </div>

                                                <div className="grid2 col-6 mb20">
                                                    <span class='fw3 m_mb_10 m_d_block'>Description</span>
                                                    <span class='fw5 col-10 w500px ov-wrap'>{annonce.description}</span>
                                                </div>

                                            </div>

                                            {

                                                localStorage.getItem('idU') == annonce.user_id

                                                    ?

                                                    <div className="col-3 m_mt_30">
                                                        <Link to={'/plant-sitting/modifier-annonce/' + annonce.idA} className="btn brc4 brc1solid cl1 bg4 ta-center d-block mb10">Modifier l'annonce</Link>
                                                        <Link to={'/plant-sitting/masquer-annonce/' + annonce.idA} href="" className="btn brc4 brc1solid cl4 bgt ta-center d-block mb10">
                                                            {
                                                                annonce.stt == 0

                                                                    ?

                                                                    <span>Masquer</span>

                                                                    :

                                                                    <span>Démasquer</span>
                                                            }
                                                        </Link>
                                                        <Link to={'/plant-sitting/supprimer-annonce/' + annonce.idA} className="btn brc4 brc1solid cl1 bg4 ta-center d-block mb10">Supprimer l'annonce</Link>
                                                    </div>

                                                    :

                                                    <div className="col-3 m_mt_30">
                                                        <Link to={'/plant-sitting/reserver/' + id} className="btn brc4 brc1solid cl1 bg4 ta-center d-block mb10">Réserver</Link>
                                                        <span className="btn brc4 brc1solid cl4 bgt ta-center d-block mb10" onClick={e => favoris(e, id)}><span className='icon fav_btn'>{annonce.isFavoris ? 'k' : 'j'}</span> Favoris</span>
                                                    </div>

                                            }

                                        </div>

                                    </div>

                                    <div class="flex bg2 br5 p10 pr20 pl20 ai-center">

                                        <Link to={'/profile/' + annonce.user_id + '/plant-sitting'} className='user'>

                                            <div class="av">
                                                <img src={Func.avatar(annonce.avatar)} />
                                            </div>

                                            <span class='t cl5 mr10'>{annonce.name}</span>

                                            {Func.note(annonce.note)}

                                        </Link>

                                    </div>

                                </div>

                            </div>

                        </div>

                        :

                        <div className="c pb40">


                            <div className='flex jc-center mt50 mb50'>
                                <div className="lds-dual-ring col"></div>
                            </div>


                        </div>

                }

                <Footer />

            </div>

        </div>

    )

}

export default PlantSittingAnnonce